export default __webpack_public_path__ + "assets/img/7c31cc32f8a4bc2faa848abc6821bd06.svg";